import { createApp } from "vue";
import App from "./App.vue";
import './assets/data-explorer.css';
import './assets/hacker-theme.css';

createApp(App).mount("#app")

